<template>
  <div class="wrapper">
    <confirm v-if="isConfirm" />
    <bad-request v-if="isBadRequest" />
    <not-found v-if="isNotFound" />
  </div>
</template>


<script>
/**
 * 使用許諾条件の確認と同意取得
 */
export default {
    name:"Board",
    computed:{
        isConfirm(){
            return this.$route.name === 'not_agree/confirm'
        },
        isBadRequest(){
            return this.$route.name === '400'
        },
        isNotFound(){
            return this.$route.name === '404' || (!this.isConfirm && !this.isBadRequest)
        }
    }
}
</script>